"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
exports.translations = {
    en: { button: "Open section" },
    ru: { button: "Перейти в раздел" },
    uz: { button: "Bo'limga o'ting" },
    kz: { button: "Бөлімге өтіңіз" },
};
